import { render, staticRenderFns } from "./MaterialAiGenerate.vue?vue&type=template&id=6e57e271&scoped=true"
import script from "./MaterialAiGenerate.vue?vue&type=script&lang=js"
export * from "./MaterialAiGenerate.vue?vue&type=script&lang=js"
import style0 from "./MaterialAiGenerate.vue?vue&type=style&index=0&id=6e57e271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e57e271",
  null
  
)

export default component.exports